import { render, staticRenderFns } from "./dashBlock.vue?vue&type=template&id=2d0a6972&"
import script from "./dashBlock.vue?vue&type=script&lang=js&"
export * from "./dashBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports